/**
 * @功能名称:
 * @文件名称: api.js
 * @Date: 2018/8/9 上午9:06.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 */
export default {
  logout:'h5/user/logout'
}
